"use strict";

exports.__esModule = true;
var endpoints_1 = require("./endpoints");
function getBrowser() {
  var ua = navigator.userAgent;
  var tem,
    M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return 'IE ' + (tem[1] || '');
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem != null) {
      return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) {
    M.splice(1, 1, tem[1]);
  }
  return M.join(' ');
}
exports.getBrowser = getBrowser;
function normalizeName(newName, oldName, set, defaultName) {
  if (newName === void 0) {
    newName = '';
  }
  newName = newName.replace(/\s+/g, ' ').trim();
  if (!newName && !oldName) newName = defaultName;
  if (!newName) newName = oldName;
  var sameNameNumbers = set.filter(function (n) {
    return n.match(new RegExp("^" + newName.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1') + "\\s?\\(?(\\d+)?\\)?$", 'gm'));
  }).map(function (n) {
    return /\s?\(?(\d+)?\)?$/gm.exec(n)[1];
  }).map(function (val) {
    return !val ? '0' : val;
  }).map(function (val) {
    return parseInt(val, 10);
  });
  if (sameNameNumbers.length !== 0) {
    newName = newName + " (" + (Math.max.apply(Math, sameNameNumbers) + 1) + ")";
  }
  return newName;
}
exports.normalizeName = normalizeName;
function addNameCounter(name, nameArray) {
  if (name && typeof name === 'string' && nameArray && Array.isArray(nameArray)) {
    var dedupedName_1 = name;
    var lowerCaseNameMap_1 = {};
    nameArray.forEach(function (key) {
      if (typeof key === 'string') {
        lowerCaseNameMap_1[key.toLowerCase()] = true;
      }
    });
    Object.keys(lowerCaseNameMap_1).forEach(function (key) {
      if (key === name.toLowerCase()) {
        var appendValue = 1;
        var uniqueValue = false;
        while (!uniqueValue) {
          dedupedName_1 = name + "-" + appendValue;
          var tempUniqueValue = true;
          if (lowerCaseNameMap_1[dedupedName_1.toLowerCase()]) {
            tempUniqueValue = false;
          }
          if (tempUniqueValue === false) {
            appendValue = appendValue + 1;
          } else {
            uniqueValue = true;
          }
        }
      }
    });
    return dedupedName_1;
  }
}
exports.addNameCounter = addNameCounter;
function getEnvironment() {
  switch (endpoints_1["default"].rootDomain) {
    case 'demo-owl.com':
      return 'demo';
    case 'staging-owl.com':
      return 'staging';
    case 'import.io':
      return 'production';
    default:
      return 'production';
  }
}
exports.getEnvironment = getEnvironment;